import React, { Fragment } from 'react';
import { styled, css } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { DensityAwareImage } from '../../components/Image/DensityAwareImage';
import { containerWidth } from '../../components/PlayContainer/PlayContainer';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SectionDetailBackground = ({
  sectionDetail,
  children
}) => {
  const {
    representation: {
      title,
      imageUrl,
      focalPoint
    }
  } = sectionDetail;
  return imageUrl ? /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(BackgroundImage, {
      src: imageUrl,
      alt: title ?? '',
      width: 1920,
      focalPoint: focalPoint
    }), /*#__PURE__*/_jsx(Gradient, {}), children]
  }) : /*#__PURE__*/_jsx(Fragment, {
    children: children
  });
};
const Container = styled.div.withConfig({
  displayName: "SectionDetailBackground__Container",
  componentId: "sc-bsjj6v-0"
})(["position:relative;max-width:", "px;margin:auto;"], containerWidth.max);
const background = css(["position:absolute;top:0;left:0;width:100%;max-height:100%;height:350px;", "{height:432px;}", "{height:784px;}", "{height:1045px;}"], Viewports.for('medium'), Viewports.for('large'), Viewports.for('xLargeUp'));
const Gradient = styled.div.withConfig({
  displayName: "SectionDetailBackground__Gradient",
  componentId: "sc-bsjj6v-1"
})(["", ";background:linear-gradient(transparent 80%,", " 100%);"], background, Colors.GREY_1a1a1a);
const BackgroundImage = styled(DensityAwareImage).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "SectionDetailBackground__BackgroundImage",
  componentId: "sc-bsjj6v-2"
})(["", ";opacity:10%;"], background);